var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M17 19.96c2.677 0 2.707 2.197 2.707 2.197v2.947c0 .749.587 1.354 1.311 1.354h4.67c.724 0 1.312-.605 1.312-1.354V15.097c0-.41-.18-.797-.488-1.055l-8.687-7.241a1.28 1.28 0 0 0-1.65 0l-8.687 7.241A1.37 1.37 0 0 0 7 15.097v10.007c0 .749.588 1.354 1.312 1.354h4.67c.724 0 1.311-.605 1.311-1.354v-2.947s.03-2.196 2.707-2.196"
})));
export default SvgIcHome;